export const getMyFarmCropDataFromStore = (state) =>
  state.digiDiaryStates.crops;

export const getMyFarmEquipmentDataFromStore = (state) =>
  state.digiDiaryStates.equipments;

export const getMyFarmExistingEquipmentDataFromStore = (state) =>
  state.digiDiaryStates.existingEquipments;

export const getCustomerId = (state) => state.mfaStates.userId;

export const getIsMachineHealthDetailsAvailable = (state) =>
  state.mfaStates.allMachineHealthDetails?.isMachineHealthDetailsAvailable;

export const getAllAvailableOffersForMFACustomer = (state) =>
  state.mfaStates.offersForMFACustomers.offers;

export const getActiveContract = (state) =>
  state.mfaStates.contractData.contracts?.find(
    (contract) => contract.loanStatus === 'BOOKED'
  );

export const getPersonalOfferData = (state) =>
  state.mfaStates.personalOfferLetterData;

export const getContractsArray = (state) =>
  state.mfaStates.contractData.contracts;

export const getSelectedCropId = (state) =>
  state.digiDiaryViewStates.selectedCropId;

export const getCropId = (state) =>
  state.digiDiaryStates.crops.length > 0 &&
  state.digiDiaryStates.crops[0].cropId;

export const getExpenseType = (state) =>
  state.digiDiaryStates?.expenseInformation?.expenseType;

export const getAllEquipment = (state) => state.digiDiaryStates.allEquipments;
export const getNonMfaUserPhoneNumber = (state) =>
  state.mfaStates.nonMfaUserData.phoneNumber;
export const getNonMfaUserSelectedOffer = (state) =>
  state.mfaStates.offersForNonMFACustomers.selectedOffer.offerId
    ? state.mfaStates.offersForNonMFACustomers.selectedOffer
    : 'NA';
